import { FC, useState } from 'react'

interface Props {
  className?: string
  color?: string
  mobile?: boolean
}

const Oval: FC<Props> = ({ className, mobile }) => {
  const [isHover, setIsHover] = useState<boolean>(false)

  return (
    <svg
      width="42"
      height="63"
      viewBox="0 0 42 63"
      className={className}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="21"
        cy="31.4998"
        rx="20"
        ry="30.5"
        fill={
          mobile === undefined && !mobile && isHover
            ? 'var(--primary-3)'
            : 'transparent'
        }
      />
      <path d="M35.8943 10.2351C32.1795 4.27908 26.9457 1 21.1694 1C15.393 1 10.1592 4.27908 6.44445 10.2351C2.93396 15.8442 1 23.3972 1 31.5C1 39.6028 2.93396 47.1558 6.44445 52.7649C10.1592 58.7209 15.393 62 21.1694 62C26.9457 62 32.1795 58.7209 35.8943 52.7649C39.4048 47.1492 41.3387 39.5962 41.3387 31.5C41.3387 23.4038 39.4048 15.8442 35.8943 10.2351ZM26.9712 52.7126L21.8778 48.5892L28.3116 45.2904L26.9712 52.7126ZM21.1694 60.9593L15.6356 53.498L21.1694 49.0146L26.7032 53.4914L21.1694 60.9593ZM15.3675 52.7126L14.0271 45.2904L20.4609 48.5892L15.3675 52.7126ZM15.3675 10.2874L20.4609 14.4108L14.0271 17.7095L15.3675 10.2874ZM21.1694 2.04067L26.7032 9.50204L21.1694 13.9854L15.6356 9.50858L21.1694 2.04067ZM26.9712 10.2874L28.3116 17.7095L21.8778 14.4108L26.9712 10.2874ZM21.1694 48.0786L13.8292 44.3152L10.0826 31.5L13.8292 18.6848L21.1694 14.9214L28.5095 18.6848L32.2561 31.5L28.5095 44.3152L21.1694 48.0786ZM9.66133 30.1975L7.26782 22.8343L12.8527 19.2869L9.66133 30.1975ZM9.66133 32.8025L12.8527 43.7131L7.26782 40.1657L9.66133 32.8025ZM32.6774 32.8025L35.0709 40.1657L29.486 43.7131L32.6774 32.8025ZM32.6774 30.1975L29.486 19.2869L35.0709 22.8343L32.6774 30.1975ZM35.1475 21.9638L29.1733 18.1677L27.6989 10.0191L35.1858 10.798L35.1475 21.9638ZM13.1654 18.1677L7.19123 21.9638L7.15293 10.8045L14.6398 10.0256L13.1654 18.1677ZM6.69976 23.5739L9.27837 31.5L6.69976 39.4261L1.83613 31.5L6.69976 23.5739ZM7.19123 41.0362L13.1654 44.8323L14.6398 52.9809L7.15293 52.202L7.19123 41.0362ZM29.1733 44.8323L35.1475 41.0362L35.1858 52.1955L27.6989 52.9744L29.1733 44.8323ZM35.639 39.4261L33.0603 31.5L35.639 23.5739L40.5026 31.5L35.639 39.4261ZM35.9134 22.5529L35.9517 11.8517C38.7473 16.8587 40.3622 23.2467 40.5536 30.1124L35.9134 22.5529ZM34.8028 9.96674L27.4372 9.20097L21.9544 1.80504C26.9266 2.07994 31.4391 4.95322 34.8028 9.96674ZM20.3843 1.80504L14.9015 9.20097L7.53589 9.96674C10.8996 4.95322 15.4122 2.07994 20.3843 1.80504ZM6.38701 11.8452L6.4253 22.5464L1.78507 30.1059C1.97655 23.2401 3.59138 16.8587 6.38701 11.8452ZM6.4253 40.4471L6.38701 51.1483C3.59138 46.1413 1.97655 39.7533 1.78507 32.8876L6.4253 40.4471ZM7.53589 53.0333L14.9015 53.799L20.3843 61.195C15.4122 60.9201 10.8996 58.0468 7.53589 53.0333ZM21.9544 61.195L27.4372 53.799L34.8028 53.0333C31.4391 58.0468 26.9266 60.9201 21.9544 61.195ZM35.9517 51.1548L35.9134 40.4471L40.5536 32.8876C40.3622 39.7599 38.7473 46.1413 35.9517 51.1548Z" />
    </svg>
  )
}

export default Oval
